export function chunk (arr, len) {
  var chunks = []
  var i = 0
  var n = arr.length

  while (i < n) {
    chunks.push(arr.slice(i, i += len))
  }

  return chunks
}

export function hasClass (el, className) {
  if (el.classList) return el.classList.contains(className)
  else return !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'))
}
export function addClass (el, className) {
  if (el.classList) el.classList.add(className)
  else if (!this.hasClass(el, className)) el.className += ' ' + className
}
export function removeClass (el, className) {
  if (el.classList) el.classList.remove(className)
  else if (this.hasClass(el, className)) {
    var reg = new RegExp('(\\s|^)' + className + '(\\s|$)')
    el.className = el.className.replace(reg, ' ')
  }
}



// WEBPACK FOOTER //
// ./src/helpers.js